// frontend/packages/business-console/src/components/build-interview/briefSummary.js
//
// Shared brief-section labels + summariser for the build interview (extracted
// from BuildInterview.jsx so the redesigned BriefPanel and review screen share
// one source). Pure formatting; never mutates the data.

export const SECTION_LABELS = {
  basics: 'Business basics',
  services: 'Services',
  serviceArea: 'Service area',
  contact: 'Contact',
  brand: 'Look and feel',
  competitors: 'Competitors',
  favoriteSites: 'Sites you like',
  proof: 'Proof',
  goals: 'Goals',
};

/** Short, human summary of a brief section's value for the brief/review panels. */
export function summarizeSection(key, value) {
  try {
    if (value == null) return 'Skipped';
    if (Array.isArray(value)) {
      if (value.length === 0) return 'Skipped';
      if (key === 'services') {
        return value
          .map((s) => `${s.name}${s.isPrimary ? ' (main)' : ''}`)
          .join(', ');
      }
      return value
        .map((v) => (typeof v === 'string' ? v : JSON.stringify(v)))
        .join(', ');
    }
    if (key === 'basics') {
      return [value.legalName, value.industry].filter(Boolean).join(' · ');
    }
    if (key === 'serviceArea') {
      return value.mode === 'storefront'
        ? value.address || 'Storefront'
        : (value.areas || []).join(', ');
    }
    if (key === 'contact') {
      return [value.phone, value.email].filter(Boolean).join(' · ');
    }
    if (key === 'brand') {
      return [
        value.useTextWordmark ? 'Text wordmark' : 'Logo',
        (value.palette || []).join(' '),
        value.tone,
      ]
        .filter(Boolean)
        .join(' · ');
    }
    if (key === 'proof') {
      const t = (value.testimonials || []).length;
      const p = (value.photoAssetIds || []).length;
      const b = (value.badges || []).length;
      return t + p + b === 0
        ? 'Skipped'
        : `${t} testimonial(s), ${p} photo(s), ${b} badge(s)`;
    }
    if (key === 'goals') {
      return [value.primaryCta, value.landingIntent].filter(Boolean).join(' · ');
    }
    return JSON.stringify(value);
  } catch (e) {
    return '';
  }
}
